import type { CSSProperties, ReactNode } from 'react';

// Fila expandible inline (fondo gris claro, sin overlay/modal) — patrón
// originado en CxCPage.tsx (F.6.2) y extraído aquí para reutilizarse también
// en Seguimientos. Reutiliza las clases .expanded-row/.expanded-grid/.exp-field
// ya existentes en globals.css — no introduce estilos nuevos.
interface ExpandedRowProps {
  colSpan: number;
  children: ReactNode;
}

export function ExpandedRow({ colSpan, children }: ExpandedRowProps) {
  return (
    <tr className="expanded-row">
      <td colSpan={colSpan}>
        <div className="expanded-grid">{children}</div>
      </td>
    </tr>
  );
}

interface ExpFieldProps {
  label: string;
  children: ReactNode;
  gridColumn?: string;
}

export function ExpField({ label, children, gridColumn }: ExpFieldProps) {
  const style: CSSProperties | undefined = gridColumn ? { gridColumn } : undefined;
  return (
    <div className="exp-field" style={style}>
      <label>{label}</label>
      <p>{children}</p>
    </div>
  );
}
